import { type LayoutPages } from '../types';
import DesktopInitPage from './DesktopInitPage';
import DesktopAuthPage from './DesktopAuthPage';
import DesktopWaitingPage from './DesktopWaitingPage';
import DesktopAgentStartPage from './DesktopAgentStartPage';
import DesktopAppPairingPage from './DesktopAppPairingPage';
import DesktopAppPresentationPage from './DesktopAppPresentationPage';
import DesktopDonePage from './DesktopDonePage';
import DesktopAbortPage from './DesktopAbortPage';
import DesktopAppPickerPage from './DesktopAppPickerPage';
import DesktopIssuanceReviewPage from './DesktopIssuanceReviewPage';
import DesktopAppInstallPage from './DesktopAppInstallPage';

export const desktopPages: LayoutPages = {
  Init: DesktopInitPage,
  Auth: DesktopAuthPage,
  WaitingForPresentation: DesktopWaitingPage,
  AgentStart: DesktopAgentStartPage,
  AppPairing: DesktopAppPairingPage,
  AppPresentation: DesktopAppPresentationPage,
  Done: DesktopDonePage,
  Abort: DesktopAbortPage,
  AppPicker: DesktopAppPickerPage,
  IssuanceReview: DesktopIssuanceReviewPage,
  AppInstall: DesktopAppInstallPage,
};

export { default as DesktopAppPickerPage } from './DesktopAppPickerPage';
export { default as DesktopIssuanceReviewPage } from './DesktopIssuanceReviewPage';
export { default as DesktopAppInstallPage } from './DesktopAppInstallPage';
